// SidebarOption.js
import React from 'react';
import { NavLink } from 'react-router-dom';

// Simple icon wrapper component
const IconWrapper = ({ icon: Icon }) => {
  return (
    <div className="icon-wrapper">
      <Icon 
        size={24}
        stroke={1.5}
        className="sidebar-icon"
      />
    </div>
  );
};

const SidebarOption = ({ active, text, icon: Icon, iconColor, comingSoon, to, onClick }) => {

  const handleClick = (e) => {
    if (comingSoon) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  const renderContent = (isActive = false) => (
    <div 
      className={`sidebar-link ${comingSoon ? 'coming-soon' : ''} ${isActive ? 'active' : ''} ${text === "Logout" ? 'logout' : ''}`}
      onClick={handleClick}
      style={{ '--icon-color': iconColor }}
    >
      <IconWrapper icon={Icon} />
      <h2>{text}</h2>
      {comingSoon && <span className="soon-badge">Soon</span>}
    </div>
  );

  if (to) {
    return (
      <div className="sidebar-option-wrapper" data-testid={`${text.toLowerCase().replace(' ', '-')}-option`}>
        <NavLink 
          to={to} 
          className="sidebar-nav-link"
        >
          {({ isActive }) => renderContent(isActive)}
        </NavLink>
      </div>
    );
  }

  return <div className="sidebar-option-wrapper">{renderContent()}</div>;
}

export default SidebarOption;